import { render, staticRenderFns } from "./VVaultSelector.vue?vue&type=template&id=353446f8&"
import script from "./VVaultSelector.vue?vue&type=script&lang=ts&"
export * from "./VVaultSelector.vue?vue&type=script&lang=ts&"
import style0 from "./VVaultSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports